import { IAppEnvironment } from '@core';
import { environmentCore } from '@core-lib/environments';

export const environmentCommon: IAppEnvironment = {
	...environmentCore,
	appName: 'e-CARPA',
	isFront: true,
	isBack: false,
	assetsPath: './assets',
	sharedAssetsPath: './shared-assets',
	labFtUrl: 'https://ssl.avocatparis.org/esep/RechercheLCBFT.aspx'
};
